import { Component, Element, h, Host, Listen, Prop, State, Watch } from "@stencil/core";

@Component({
    tag: "ux-tab-button",
    styleUrl: "tab-button.scss",
    shadow: false
})
export class TabButton {
    @Element() domNode!: HTMLUxTabButtonElement;

    /** Displays the label of the tab */
    /* eslint-disable-next-line */
    @Prop({ reflect: true }) name: string = "";

    /** Contains the current active tab string */
    @Prop({ reflect: true }) readonly activeTab: string;

    /** Contains this tabs ID */
    @Prop({ reflect: true }) readonly tabId: string = "";

    @State() active = false;

    @Watch("activeTab")
    componentWillLoad() {
        this.active = this.activeTab === this.tabId;
    }

    @Listen("uxTabNameChange", { target: "window" })
    updateTabButtonName(e: CustomEvent) {
        if (e.detail.tabId === this.tabId) {
            this.name = e.detail.tabName;
        }
    }

    render() {
        return (
            <Host class={`ux-tab-button ${this.active ? "is-active" : ""}`}>
                <div class="ux-tab-button__label" id={this.tabId}>
                    <slot />
                    {this.name}
                </div>
            </Host>
        );
    }
}
